const { registerBlockType } = wp.blocks;
import { InspectorControls, RichText, PanelColorSettings, FontSizePicker } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, RangeControl, BaseControl, SelectControl, TextControl,  __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalInputControl as InputControl, TextareaControl } from "@wordpress/components";
import {fontfamilylist} from "./lib/fontfamilylist.js";
const fontSizes=[
	{
		name: 'Tiny',
		slug: 'tiny',
		size: 8,
	},
	{
		name: 'Small',
		slug: 'small',
		size: 12,
	},
	{
		name: 'Normal',
		slug: 'normal',
		size: 16,
	},
	{
		name: 'Big',
		slug: 'big',
		size: 26,
	},
	{
		name: 'Bigger',
		slug: 'bigger',
		size: 30,
	},
	{
		name: 'Huge',
		slug: 'huge',
		size: 36,
	},
];
const fallbackTitleFontSize = 20;
const fallbackContentFontSize = 20;
const { __ } = wp.i18n;

registerBlockType('spice-blocks/spice-progress-bar',{
    title:__('Progress Bar','spice-blocks'),
    category:'spice-blocks',
    icon: <svg width="24" height="24" viewBox="0 0 455.138 455.139" aria-hidden="true" focusable="false"><path stroke="#09A223" fill="#09A223" d="M0,141.653v171.832h455.138V141.653H0z M432.721,291.071H22.414V164.067h410.312v127.004H432.721z M104.294,271.465H44.528 v-89.652h59.767V271.465z M193.947,271.465h-59.765v-89.652h59.765V271.465z M287.334,271.465h-59.768v-89.652h59.768V271.465z" ></path></svg>,
    keywords: [
        __('Spice Progress Bar','spice-blocks'),
        __('Progress Bar','spice-blocks'),
        __('Horizontal Bar','spice-blocks')
     ],
     example: {
		"attributes": {
			"beforeImageUrl": "https://i.postimg.cc/v8WNPMGL/home-before.jpg",
			"afterImageUrl": "https://i.postimg.cc/m2B6JqDx/home-after.jpg"
		}
	},
    attributes: {
        uniqueId:{
            type:'string'
        },
        enableTitle: {
            type:'boolean',
            default:true
        },
        enableProgressTxt: {
            type:'boolean',
            default:true
        },
        sectionMargin: {
            default: {
                top: '0px',
                right: 'auto',
                bottom: '0px',
                left: 'auto'
            }
        },
        sectionOuterPaddings: {
            default: {
                top: '20px',
                right: '0px',
                bottom: '20px',
                left: '0px'
            }
        },
        sectionInnerPaddings: {
            default: {
                top: '18px',
                right: '30px',
                bottom: '30px',
                left: '20px'
            }
        },
        titlePaddings: {
            default: {
                top: '0',
                right: '0',
                bottom: '15px',
                left: '0'
            }
        },
        progressWidth:{
            type:'number',
            default:80
        },
        progressHeading: {
            type: 'string',
            default: 'Wordpress'
        },
        shadowColor:{
            type:'string',
            default:'#dedede'
        },
        backgroundColor:{
            type:'string',
            default:'#ffffff'
        },
        titleColor:{
            type:'string',
            default:'#000000'
        },
        progressBarColor:{
            type:'string',
            default:'#7cc048'
        },
        progressColor:{
            type:'string',
            default:'#000000'
        },
        titleFamily:{
            type:'string',
            default:'Oswald'
        },
        titleSize:{
            type:'string',
            default:'24px'
        },
        titleWeight:{
            type:'string',
            default:700
        },
        titleHeight:{
            type:'number'
        },
        titleTransform:{
            type:'string'
        },
        titleDecoration:{
            type:'string'
        },
        titleLetterSpacing:{
            type:'number'
        },
        contentFamily:{
            type:'string',
            default:'Oswald'
        },
        contentSize:{
            type:'string',
            default:'20px'
        },
        contentWeight:{
            type:'string',
            default:600
        },
        contentHeight:{
            type:'number'
        },
        contentDecoration:{
            type:'string'
        },
        contentLetterSpacing:{
            type:'number'
        },
        hshadow: {
            type: 'number',
            default: 0
        },
        vshadow: {
            type: 'number',
            default: 0
        },
        blurshadow: {
            type: 'number',
            default: 20
        },
        animation:{
            type:'string',
            default:'None'
        },
        durations:{
            type:'string',
            default:' '
        },
        delay:{
            type:'string',
        },
        hidedesktop:{
            type:'boolean',
            default:true
        },
        hidetablet:{
            type:'boolean',
            default:true
        },
        hidemobile:{
            type:'boolean',
            default:true
        },
        addclass:{
            type:'string',
        },
        customcss:{
            type:'string',
        }
    },
    edit: function({attributes, setAttributes, clientId}){
            const{ uniqueId, enableTitle, enableProgressTxt, sectionMargin, sectionOuterPaddings, sectionInnerPaddings, titlePaddings, progressWidth, progressHeading, shadowColor, backgroundColor, titleColor, progressBarColor, progressColor, titleFamily, titleSize, titleWeight, titleHeight, titleTransform, titleDecoration, titleLetterSpacing, contentFamily, contentSize, contentWeight, contentHeight, contentDecoration, contentLetterSpacing, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, addclass, customcss } = attributes;
            const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
            const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
            // set unique ID
            setAttributes({ uniqueId: clientId.slice(0, 8), }); 
            function setBgColor(value){
                setAttributes({backgroundColor :value})
            }
            function setTitleColor(value){
                setAttributes({titleColor :value})
            }
            function setprogressBarColor(value){
                setAttributes({progressBarColor :value})
            }
            function setprogressColor(value){
                setAttributes({progressColor :value})
            }

            if(titleFamily !=null){
                let url = 'https://fonts.googleapis.com/css2?family='+titleFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                 let link = document.createElement('link')
                  link.href = url;
                  link.rel = "stylesheet";
                  link.type =  "text/css";
                  
                  if ( jQuery("body").hasClass("site-editor-php") ) { 
                  jQuery('iframe').contents().find("head").append(link);
              }
              else{
                  document.head.appendChild(link);
              }
            } 
            if(contentFamily !=null){
                let url2 = 'https://fonts.googleapis.com/css2?family='+contentFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                 let link = document.createElement('link')
                  link.href = url2;
                  link.rel = "stylesheet";
                  link.type =  "text/css";
                  
                  if ( jQuery("body").hasClass("site-editor-php") ) { 
                  jQuery('iframe').contents().find("head").append(link);
              }
              else{
                  document.head.appendChild(link);
              }
            }

            return([<>
                    <InspectorControls>
                        <PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>
                            <ToggleControl
                                label={__('Enable/Disable Title','spice-blocks')}
                                checked={enableTitle}
                                onChange={(userVal) => setAttributes({ enableTitle: userVal })}
                            />
                            <ToggleControl
                                label={__('Enable/Disable Progress Text','spice-blocks')}
                                checked={enableProgressTxt}
                                onChange={(userVal) => setAttributes({ enableProgressTxt: userVal })}
                            />
                            <RangeControl
                                label={__('Progress Bar(Width)','spice-blocks')}
                                value={progressWidth}
                                onChange={(userVal) => setAttributes({progressWidth:userVal})}
                                min={0}
                                max={100}
                                step={1}
                            />
                            <PanelBody initialOpen={false} title={__('Spacing','spice-blocks')} className={'spice-panel-edit margin'}>
                                <BoxControl 
                                    label={__('Section Margin','spice-blocks')}
                                    values={sectionMargin}
                                    inputProps={{ min: -300 }}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        sectionMargin:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                />
                                <BoxControl 
                                    label={__('Section Outer Padding','spice-blocks')}
                                    values={sectionOuterPaddings}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        sectionOuterPaddings:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                /> 
                                <BoxControl 
                                    label={__('Section Inner Padding','spice-blocks')}
                                    values={sectionInnerPaddings}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        sectionInnerPaddings:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                />
                                <BoxControl 
                                    label={__('Title Padding','spice-blocks')}
                                    values={titlePaddings}
                                    sides={['top', 'right','bottom','left']}
                                    allowReset={false}
                                    units={[]}
                                    onChange={(userVal) => setAttributes({
                                        titlePaddings:{
                                            top:userVal.top,
                                            right:userVal.right,
                                            bottom:userVal.bottom,
                                            left:userVal.left
                                        }
                                    })}
                                />
                            </PanelBody>
                            
                            <PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
                                <SelectControl
                                    label={__('Animation','spice-blocks')}
                                    value={ animation }
                                    options={ [
                                                { label: __('None','spice-blocks'), value: ' ' },
                                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                                            ] }
                                    onChange={ (userVal) => setAttributes({ animation: userVal }) }					  
                                />  
                                <SelectControl
                                    label={__('Durations','spice-blocks')}
                                    value={ durations }
                                    options={ [
                                                { label: __('Normal','spice-blocks'), value: ' '    },
                                                { label: __('Slow','spice-blocks'),   value: 'slow' },
                                                { label: __('Fast','spice-blocks'),   value: 'fast' },
                                            ] }
                                    onChange={ (userVal) => setAttributes({ durations: userVal }) }					  
                                />  
                                <TextControl
                                    label={__('Delay(ms)','spice-blocks')}			    
                                    value={delay}
                                    onChange={(userVal) => setAttributes({ delay: userVal })}
                                />
                            </PanelBody>
                            <PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'} >					
                                <ToggleControl
                                    label={__('Enable/Disable on Desktop','spice-blocks')}
                                    checked={hidedesktop}
                                    onChange={(userVal) => setAttributes({ hidedesktop: userVal })}
                                />
                                <ToggleControl
                                    label={__('Enable/Disable on Tablet','spice-blocks')}
                                    checked={hidetablet}
                                    onChange={(userVal) => setAttributes({ hidetablet: userVal })}
                                />
                                <ToggleControl
                                    label={__('Enable/Disable on Mobile','spice-blocks')}
                                    checked={hidemobile}
                                    onChange={(userVal) => setAttributes({ hidemobile: userVal })}
                                />
                            </PanelBody>
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Box Shadow','spice-blocks')}>	
                            <RangeControl 
                                label={__('Horizontal Shadow(px)','spice-blocks')}			    
                                value={ hshadow}
                                onChange={(userVal) => setAttributes({ hshadow: userVal })}
                                min={0}
                                max={100}
                            />
                            <RangeControl 
                                label={__('Vertical Shadow(px)','spice-blocks')}			    
                                value={ vshadow} onChange={(userVal) => setAttributes({ vshadow: userVal })}
                                min={0}
                                max={100}
                            />	
                            <RangeControl 
                                label={__('Blur Shadow(px)','spice-blocks')}			    
                                value={ blurshadow}
                                onChange={(userVal) => setAttributes({ blurshadow: userVal })}
                                min={0}
                                max={100}
                            />
                            <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                                title={__('Background & Color Settings','spice-blocks')}
                                colorSettings={[
                                    {
                                        value: shadowColor,
                                        enableAlpha:true,
                                        onChange: (colors) => setAttributes({ shadowColor: colors }),
                                        label: __('Box Shadow','spice-blocks')
                                    },
                                ]}
                            />
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Color Settings','spice-blocks')}>
                            <PanelColorSettings initialOpen={false} className={"spice-block-color-tab-panel"}
                                title={__('Background & Color Settings','spice-blocks')}
                                colorSettings={[
                                    {
                                        value: backgroundColor,
                                        enableAlpha:true,
                                        onChange: setBgColor,
                                        label: __('Background','spice-blocks')
                                    },
                                    {
                                        value: titleColor,
                                        enableAlpha:true,
                                        onChange: setTitleColor,
                                        label: __('Title','spice-blocks')
                                    },
                                    {
                                        value: progressBarColor,
                                        enableAlpha:true,
                                        onChange: setprogressBarColor,
                                        label: __('Progress Bar','spice-blocks')
                                    },
                                    {
                                        value: progressColor,
                                        enableAlpha:true,
                                        onChange: setprogressColor,
                                        label: __('Progress Text','spice-blocks')
                                    },
                                    
                                ]}
                            />
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')}>
                            <PanelBody initialOpen={false} title={__('Title Typography','spice-blocks')}>
                                <SelectControl
                                    label={__(' Font Family','spice-blocks')}
                                    value={ titleFamily }
                                    options={fontfamilylist}
                                    onChange={ (newtext) => setAttributes({ titleFamily: newtext }) }
                                />
                                <FontSizePicker 
                                    __nextHasNoMarginBottom
                                    fontSizes={ fontSizes }
                                    value={ titleSize }
                                    fallbackFontSize={ fallbackTitleFontSize }
                                    onChange={(userVal) => setAttributes({titleSize: userVal})}
                                    allowReset={false}
                                />
                                <SelectControl
                                    label={__('Font Weight','spice-blocks')}
                                    options= {[
                                        { label: __('Thin','spice-blocks'), value: '100' },
                                        { label: __('Extra Light','spice-blocks'), value: '200' },
                                        { label: __('Light','spice-blocks'), value: '300' },
                                        { label: __('Regular','spice-blocks'), value: '400' },
                                        { label: __('Medium','spice-blocks'), value: '500' },
                                        { label: __('Semi Bold','spice-blocks'), value: '600' },
                                        { label: __('Bold','spice-blocks'), value: '700' },
                                        { label: __('Extra Bold','spice-blocks'), value: '800' },
                                        { label: __('Black','spice-blocks'), value: '900' }
                                    ]}
                                    value={titleWeight}
                                    onChange={ (userVal) => setAttributes({ titleWeight: userVal }) }
                                />
                                <RangeControl 
                                    label={__('line Height(px)','spice-blocks')}
                                    value={titleHeight}
                                    min={0}
                                    max={100}
                                    onChange={(userVal) => setAttributes({titleHeight: userVal})}
                                />
                                <SelectControl
                                    label={__('Text Transform','spice-blocks')}
                                    options={[
                                        { label: __('Default','spice-blocks'), value: '' },
                                        { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
                                        { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
                                        { label: __('Capitalize','spice-blocks'), value: 'capitalize' }
                                    ]}
                                    value={titleTransform}
                                    onChange={(userVal) => setAttributes({titleTransform:userVal})}
                                />
                                <SelectControl 
                                    label={__('Text Decoration','spice-blocks')}
                                    options={[
                                        { label: __('Default','spice-blocks'), value: '' },
                                        { label: __('Underline','spice-blocks'), value: 'underline' },
                                        { label: __('Overline','spice-blocks'), value: 'overline' },
                                        { label: __('Line Through','spice-blocks'), value: 'line-through' }
                                    ]}
                                    value={titleDecoration}
                                    onChange={(userVal) => setAttributes({titleDecoration:userVal})}
                                />
                                 <RangeControl 
                                    label={__('Letter Spacing','spice-blocks')}
                                    value={titleLetterSpacing}
                                    min={-10.0}
                                    max={10.0}
                                    onChange={(userVal)=> setAttributes({titleLetterSpacing:userVal})}
                                />
                            </PanelBody>
                            <PanelBody initialOpen={false} title={__('Progress Text Typography','spice-blocks')}>
                                <SelectControl
                                    label={__(' Font Family','spice-blocks')}
                                    value={ contentFamily }
                                    options={fontfamilylist}
                                    onChange={ (newtext) => setAttributes({ contentFamily: newtext }) }
                                />
                                                                
                                <FontSizePicker 
                                    __nextHasNoMarginBottom
                                    fontSizes={ fontSizes }
                                    value={ contentSize }
                                    fallbackFontSize={ fallbackContentFontSize }
                                    onChange={(userVal) => setAttributes({contentSize: userVal})}
                                    allowReset={false}
                                />

                                <SelectControl
                                    label={__('Font Weight','spice-blocks')}
                                    options= {[
                                        { label: __('Thin','spice-blocks'), value: '100' },
                                        { label: __('Extra Light','spice-blocks'), value: '200' },
                                        { label: __('Light','spice-blocks'), value: '300' },
                                        { label: __('Regular','spice-blocks'), value: '400' },
                                        { label: __('Medium','spice-blocks'), value: '500' },
                                        { label: __('Semi Bold','spice-blocks'), value: '600' },
                                        { label: __('Bold','spice-blocks'), value: '700' },
                                        { label: __('Extra Bold','spice-blocks'), value: '800' },
                                        { label: __('Black','spice-blocks'), value: '900' }
                                    ]}
                                    value={contentWeight}
                                    onChange={ (userVal) => setAttributes({ contentWeight: userVal }) }
                                />

                                <RangeControl 
                                    label={__('line Height(px)','spice-blocks')}
                                    value={contentHeight}
                                    min={0}
                                    max={100}
                                    onChange={(userVal) => setAttributes({contentHeight: userVal})}
                                />

                                <SelectControl 
                                    label={__('Text Decoration','spice-blocks')}
                                    options={[
                                        { label: __('Default','spice-blocks'), value: '' },
                                        { label: __('Underline','spice-blocks'), value: 'underline' },
                                        { label: __('Overline','spice-blocks'), value: 'overline' },
                                        { label: __('Line Through','spice-blocks'), value: 'line-through' }
                                    ]}
                                    value={contentDecoration}
                                    onChange={(userVal) => setAttributes({contentDecoration:userVal})}
                                />

                                <RangeControl 
                                    label={__('Letter Spacing','spice-blocks')}
                                    value={contentLetterSpacing}
                                    min={-10.0}
                                    max={10.0}
                                    onChange={(userVal)=> setAttributes({contentLetterSpacing:userVal})}
                                />
                            </PanelBody>
                            
                        </PanelBody>
                        <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                            <InputControl
                                label={__('Additional Class','spice-blocks')}
                                value={ addclass }
                                onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                            />
                            <TextareaControl
                                label={__('Custom CSS','spice-blocks')}
                                value={ customcss }
                                onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                            />
                        </PanelBody>
                    </InspectorControls>
                    <style dangerouslySetInnerHTML={{
                    __html:[
                        `#block-${clientId} .spice-skills-bar{
                            margin: ${sectionMargin.top} ${sectionMargin.right ? sectionMargin.right: 'auto'} ${sectionMargin.bottom} ${sectionMargin.left ? sectionMargin.left: 'auto'};
                            padding: ${sectionOuterPaddings.top} ${sectionOuterPaddings.right} ${sectionOuterPaddings.bottom} ${sectionOuterPaddings.left};
                            animation-delay: ${delay}ms;
                        }
                        #block-${clientId} .spice-skills-bar .spicebar{
                            padding: ${sectionInnerPaddings.top} ${sectionInnerPaddings.right} ${sectionInnerPaddings.bottom} ${sectionInnerPaddings.left};
                            background: ${backgroundColor};
                            box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spiceinfo{
                            padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spiceinfo span{
                            color: ${titleColor}; 
                            font-family: ${titleFamily};
                            font-size: ${titleSize};
                            font-weight: ${titleWeight};
                            text-transform: ${titleTransform};
                            text-decoration: ${titleDecoration};
                            line-height: ${titleHeight}px;
                            letter-spacing: ${titleLetterSpacing}px;
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spice-progress .sp-number{
                            color: ${progressColor};
                            font-family: ${contentFamily};
                            font-size: ${contentSize};
                            font-weight: ${contentWeight};
                            text-decoration: ${contentDecoration};
                            line-height: ${contentHeight}px;
                            letter-spacing: ${contentLetterSpacing}px;
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spice-progress span{
                            width: ${progressWidth}%;
                            background: ${progressBarColor}; 
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spice-progress span::before
                        {
                            background: ${progressBarColor};
                            border: 1px solid ${progressBarColor};
                        }
                        #block-${clientId} .spice-skills-bar .spicebar .spice-progress span::after
                        {
                            border: 1px solid ${progressBarColor};
                        }
                        ${customcss}`
                    ].join('\n')
                }}>
                    </style>
                    <div className={`spice-skills-bar ${animationclass} ${displayclass} ${addclass}`}>
                        <div class="spicebar">
                            <div class="spiceinfo">
                                { enableTitle == true && [
                                <RichText 
                                    tagName="span"
                                    value={progressHeading}
                                    onChange={(userVal) => setAttributes({progressHeading: userVal})}   
                                />
                                ]}
                            </div>
                            <div class="spice-progress"><span></span>
                                { enableProgressTxt && [
                                    <div class="sp-number sp-one">{progressWidth}%</div>
                                ]}
                            </div>
                        </div>
                    </div>
            </>])
    },
    save: function({attributes}){
            const{ uniqueId, enableTitle, enableProgressTxt, sectionMargin, sectionOuterPaddings, sectionInnerPaddings, titlePaddings, progressWidth, progressHeading, shadowColor, backgroundColor, titleColor, progressBarColor, progressColor, titleFamily, titleSize, titleWeight, titleHeight, titleTransform, titleDecoration, titleLetterSpacing, contentFamily, contentSize, contentWeight, contentHeight, contentDecoration, contentLetterSpacing, hshadow, vshadow, blurshadow, animation, durations, delay, hidedesktop, hidetablet, hidemobile, addclass, customcss } = attributes;
            const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
            const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
            const displaytablet=(hidetablet == false)   ? 'hide-tablet' : '';
            const displaymobile=(hidemobile == false)   ? 'hide-mobile' : '';
            const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
            
            return(<>
                    <style dangerouslySetInnerHTML={{
                    __html:[
                        `#spice-skill-${uniqueId}{
                            margin: ${sectionMargin.top} ${sectionMargin.right ? sectionMargin.right: 'auto'} ${sectionMargin.bottom} ${sectionMargin.left ? sectionMargin.left : 'auto'};
                            padding: ${sectionOuterPaddings.top} ${sectionOuterPaddings.right} ${sectionOuterPaddings.bottom} ${sectionOuterPaddings.left};
                            animation-delay: ${delay}ms;
                        }
                        #spice-skill-${uniqueId} .spicebar{
                            padding: ${sectionInnerPaddings.top} ${sectionInnerPaddings.right} ${sectionInnerPaddings.bottom} ${sectionInnerPaddings.left};
                            background: ${backgroundColor};
                            box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
                        }
                        #spice-skill-${uniqueId} .spicebar .spiceinfo{
                            padding: ${titlePaddings.top} ${titlePaddings.right} ${titlePaddings.bottom} ${titlePaddings.left};
                        }
                        #spice-skill-${uniqueId} .spicebar .spiceinfo span{
                            color: ${titleColor}; 
                            font-family: ${titleFamily};
                            font-size: ${titleSize};
                            font-weight: ${titleWeight};
                            text-transform: ${titleTransform};
                            text-decoration: ${titleDecoration};
                            line-height: ${titleHeight}px;
                            letter-spacing: ${titleLetterSpacing}px;
                        }
                        #spice-skill-${uniqueId} .spicebar .spice-progress .sp-number{
                            color: ${progressColor};
                            font-family: ${contentFamily};
                            font-size: ${contentSize};
                            font-weight: ${contentWeight};
                            text-decoration: ${contentDecoration};
                            line-height: ${contentHeight}px;
                            letter-spacing: ${contentLetterSpacing}px;
                        }
                        #spice-skill-${uniqueId} .spicebar .spice-progress span{
                            width: ${progressWidth}%;
                            background: ${progressBarColor}; 
                        }
                        #spice-skill-${uniqueId} .spicebar .spice-progress span::before
                        {
                            background: ${progressBarColor};
                            border: 1px solid ${progressBarColor};
                        }
                        #spice-skill-${uniqueId} .spicebar .spice-progress span::after
                        {
                            border: 1px solid ${progressBarColor};
                        }
                        #spice-skill-${uniqueId}.spice-skills-bar .spicebar .spice-progress .sp-number {
                            color: ${progressColor};
                            font-family: ${contentFamily};
                            font-size: ${contentSize};
                            font-weight: ${contentWeight};
                            text-decoration: ${contentDecoration};
                            line-height: ${contentHeight}px;
                            letter-spacing: ${contentLetterSpacing}px;
                        }
                        #spice-skill-${uniqueId} .spice-skills-bar .spicebar .spice-progress span::after
                        {
                            border: 1px solid ${progressBarColor};
                        }
                        ${customcss}
                        `
                    ].join('\n')
                }}>
                    </style>
                    <script> 
                        var titleFamily=`{titleFamily}`;
                        var url = 'https://fonts.googleapis.com/css2?family='+titleFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                        var link = document.createElement('link');
                        link.href = url;
                        link.rel = "stylesheet";
                        link.type =  "text/css";	          
                        document.head.appendChild(link);
				    </script>	
                    <script> 
                        var contentFamily=`{contentFamily}`;
                        var url2 = 'https://fonts.googleapis.com/css2?family='+contentFamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
                        var link2 = document.createElement('link');
                        link2.href = url2;
                        link2.rel = "stylesheet";
                        link2.type =  "text/css";	          
                        document.head.appendChild(link2);
				    </script>	
                    <div className={`spice-skills-bar front-end ${animationclass} ${displayclass} ${attributes.className} ${addclass}`} id={`spice-skill-${uniqueId}`}>
                        <div class="spicebar">
                            <div class="spiceinfo">
                                { enableTitle == true && [
                                <RichText.Content
                                    tagName="span"
                                    value={progressHeading}
                                    onChange={(userVal) => setAttributes({progressHeading: userVal})}   
                                />
                                ]}
                            </div>
                            <div class="spice-progress"><span></span>
                                
                            
                            { enableProgressTxt && [
                                    <div class="sp-number sp-one">{progressWidth}%</div>
                                ]}

</div>
                        </div>
                    </div>
                    </>)
    }
})